<template>
  <div
    class="divHeadFirstWidge"
    v-lazy:background-image="{
      src: headBg,
      loading: headBgLazy,
    }"
  >
    <div class="divContent">
      <subject-flow-widge
        :subject="subject"
        :project="name"
        :routerLink="routerLink"
      ></subject-flow-widge>
      <div class="divFlexContent">
        <div class="divName">
          <img v-lazy="nameImg" />
        </div>
        <div class="divDesc">
          {{ desc }}
        </div>
        <pre-publish-widge
          :data="date"
          color="rgb(71, 138, 239)"
          bgColor="rgb(225, 238, 255)"
          :links="linkData"
        ></pre-publish-widge>
      </div>
    </div>
    <div class="divProject">
      <div class="divIndustry">
        <img class="divImg" :src="logo" />
        <span class="spanDesc">{{ logoDesc }}</span>
      </div>
      <div class="divNum">
        <ul>
          <li v-for="(item, index) in numItems" :key="index">
            <p class="pNum">
              {{ item.num }} <em>{{ item.unit }}</em>
            </p>
            <p class="pDesc">{{ item.type }}</p>
          </li>
        </ul>
      </div>
      <div class="divVideo" @click="handleVideo(video)" v-if="video">
        <div class="divBox"></div>
        <div class="divTriangle">
          <img src="../../common/img/video_orange.png" />
        </div>
        <div class="videoDesc">项目介绍</div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>

<script>
import MenuAdd from "./../../../../components/video";
import subjectFlowWidge from "./../../../../components/subjectFlowWidge";
import prePublishWidge from './../../common/components/prePublishWidge'
export default {
  components: {
    subjectFlowWidge,
    prePublishWidge,
    MenuAdd,
  },
  props: {
    subject: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: "",
    },
    logoDesc: {
      type: String,
      default: "",
    },
    numItems: {
      type: Array,
      default: () => [],
    },
    video: {
      type: String,
      default: "",
    },
    nameImg: {
      type: String,
      default: "",
    },
    headBg: {
      type: String,
      default: require("./../img/headBg1.png"),
    },
    headBgLazy: {
      type: String,
      default: require("./../img/headBg1.jpg"),
    },
    linkData:{
      type:Array,
      default:()=>[]
    }
  },
  computed: {
    routerLink() {
      return {
        path: "/java",
      };
    },
  },
  methods: {
    handleVideo(url) {
      this.$trackEvent("视频介绍", "点击", "前端学科");
      let obj = {
        url: url,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/headFirstWidge.scss";
</style>
